export const osnTop1010SIcon = {
  data: `<svg viewBox="0 0 284 210" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.5"><path
d="M100.6 201V14.2399H65.88L7.08002 73.3199L29.76 97.1199L60.56 65.4799V201H100.6Z" fill="#0F0125"/><path d="M117.437
107.76C117.437 155.92 141.237 204.36 194.717 204.36C247.917 204.36 271.997 155.92 271.997 107.76C271.997 59.6 247.917
11.4399 194.717 11.4399C141.237 11.4399 117.437 59.6 117.437 107.76ZM231.397 107.76C231.397 142.2 221.317 169.08
194.717 169.08C167.837 169.08 157.757 142.2 157.757 107.76C157.757 73.32 167.837 46.72 194.717 46.72C221.317 46.72
231.397 73.32 231.397 107.76Z" fill="#0F0125"/><path d="M100.6 201V14.2399H65.88L7.08002 73.3199L29.76 97.1199L60.56
65.4799V201H100.6Z" stroke="white" stroke-width="8.9375"/><path d="M117.437 107.76C117.437 155.92 141.237 204.36
194.717 204.36C247.917 204.36 271.997 155.92 271.997 107.76C271.997 59.6 247.917 11.4399 194.717 11.4399C141.237
11.4399 117.437 59.6 117.437 107.76ZM231.397 107.76C231.397 142.2 221.317 169.08 194.717 169.08C167.837 169.08 157.757
142.2 157.757 107.76C157.757 73.32 167.837 46.72 194.717 46.72C221.317 46.72 231.397 73.32 231.397 107.76Z"
 stroke="currentColor" stroke-width="8.9375"/></g></svg>`,
  name: 'top-10-10-s',
};
